import React from "react";
import img from "../../Images/pdf-icon.png";
import file from "../../Images/premier-destination.PDF";

const Pdf = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <a href={file} target="_blank" rel="noreferrer">
          <img src={img} alt="icon" />
          <p>Premier Destinations </p>
        </a>
      </div>
    </div>
  );
};
export default Pdf;
